import { useId, useState } from "react";

import CheckIcon from "@mui/icons-material/Check";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

import { CaseNoteListFilter } from "@/pages/clients/client/components/tabs/notes-tab/CaseNotes.types";
import { useTranslation } from "@/translations";

interface Props {
  filter: CaseNoteListFilter;
  onChange: (filter: CaseNoteListFilter) => void;
}

export function CaseNotesFilterMenu({ filter, onChange }: Props) {
  const { t } = useTranslation();
  const menuId = useId();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const isOpen = Boolean(anchor);

  const items = [
    { value: CaseNoteListFilter.All, label: t("clients.client.caseNotes.filter.all") },
    {
      value: CaseNoteListFilter.AppointmentNotesOnly,
      label: t("clients.client.caseNotes.filter.appointmentNotesOnly"),
    },
  ];

  function handleSelect(value: CaseNoteListFilter) {
    setAnchor(null);
    onChange(value);
  }

  return (
    <>
      <IconButton
        aria-label={t("clients.client.moreOptions")}
        aria-haspopup="menu"
        aria-controls={isOpen ? menuId : undefined}
        aria-expanded={isOpen}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu id={menuId} anchorEl={anchor} open={isOpen} onClose={() => setAnchor(null)}>
        {items.map(({ value, label }) => {
          const isSelected = value === filter;

          return (
            <MenuItem
              key={value}
              role="menuitemradio"
              aria-checked={isSelected}
              selected={isSelected}
              onClick={() => handleSelect(value)}
            >
              <ListItemIcon>{isSelected && <CheckIcon fontSize="small" />}</ListItemIcon>
              <ListItemText>{label}</ListItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
